import { useTranslation } from 'react-i18next'
import { Body1, Body2, Box, Card, Grid, H6 } from '@dhl-ui/components'

import { UserForm } from '~/modules/users/components'
import { getUserTypeLabel, type User } from '~/modules/users/model'

type Props = {
  user: User
  onCancel: () => void
}

export const ProfileForm = ({ user, onCancel }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Card.Header title={t('admin.usersPage.profileView.titleText')} />
      <Card.Content>
        <Grid container direction="column" spacing={1}>
          <Grid>
            <H6>{t('admin.usersPage.profileView.accountText')}</H6>
          </Grid>
          <Grid>
            <Box marginTop={2}>
              <Body2 variant="tertiary">{t('admin.usersPage.profileView.userType')}</Body2>
              <Body1 data-testid="user-userType">{getUserTypeLabel(user.userType)}</Body1>
            </Box>
          </Grid>
          <Grid>
            <UserForm disableEmailField={true} onCancel={onCancel} user={user} />
          </Grid>
        </Grid>
      </Card.Content>
    </Card>
  )
}
